<app-header></app-header>
<div class="corpo-pagina">
	<router-outlet></router-outlet>
</div>
<app-footer></app-footer>
